import { Routes } from '@angular/router';

export const buscaMedicoIntercambistaRmsRoutes: Routes = [
  {
    path: 'busca-medico-intercambista',
    data: {
      title: 'Busca de Médico Intercambista',
      breadcrumb: [{ label: 'Busca de Médico Intercambista', url: '/busca-medico-intercambista' }],
    },
    loadComponent: () =>
      import('./busca-medico-intercambista-rms.component').then(
        (m) => m.BuscaMedicoIntercambistaRmsComponent,
      ),
  },
];
